export const HMS_IFRAME_MESSAGES = {
  authToken: "HMS_AUTH_TOKEN",
  ready: "APPOINTMENT_READY",
  authRequest: "APPOINTMENT_AUTH_REQUEST",
  close: "APPOINTMENT_CLOSE",
  navigate: "APPOINTMENT_NAVIGATE",
};
